export const NEW_TRANSLATION_KEYS = {
  ACTIVE_SESSIONS: { key: "activeSessionsKey", value: "Active sessions" },
  ACTIVE_SESSIONS_DESCRIPTION: { key: "activeSessionsDescriptionKey", value: "Devices and browsers currently signed in to your account." },
  LOADING_ACTIVE_SESSIONS: { key: "loadingActiveSessionsKey", value: "Loading active sessions…" },
  COULD_NOT_LOAD_ACTIVE_SESSIONS: { key: "couldNotLoadActiveSessionsKey", value: "Could not load active sessions." },
  THIS_DEVICE: { key: "thisDeviceKey", value: "this device" },
  THIS_BROWSER: { key: "thisBrowserKey", value: "This browser" },
  LAST_ACTIVE: { key: "lastActiveKey", value: "Last active" },
  COUNTRY: { key: "countryKey", value: "Country" },
  REVOKE: { key: "revokeKey", value: "Revoke" },
  REVOKE_ALL_OTHER_SESSIONS: { key: "revokeAllOtherSessionsKey", value: "Revoke all other sessions" },
  END_THIS_SESSION: { key: "endThisSessionKey", value: "End this session?" },
  SESSION_SIGN_IN_AGAIN: { key: "sessionSignInAgainKey", value: "This device or browser will need to sign in again." },
  END_SESSION: { key: "endSessionKey", value: "End session" },
  END_ALL_OTHER_SESSIONS: { key: "endAllOtherSessionsKey", value: "End all other sessions?" },
  OTHER_SESSIONS_SIGN_IN_AGAIN: { key: "otherSessionsSignInAgainKey", value: "Every other device and browser will need to sign in again." },
  END_SESSIONS: { key: "endSessionsKey", value: "End sessions" },
  APPEARANCE: { key: "appearanceKey", value: "Appearance" },
  LOGOUT: { key: "logoutKey", value: "Logout" },
  PLAN: { key: "planKey", value: "Plan" },
} as const

export const LANG_KEYS: Record<string, { key: string; value: string }> = {
  ...NEW_TRANSLATION_KEYS,
  MY_LIBRARY: {
    key: "myLibraryKey",
    value: "My library",
  },
  ADD_CONTENT: {
    key: "addContentKey",
    value: "Add content",
  },
  SETTINGS: {
    key: "settingsKey",
    value: "Settings",
  },
  ACCOUNT: {
    key: "accountKey",
    value: "Account",
  },
  SIGN_UP_FOR_AN_ACCOUNT: {
    key: "signUpForAnAccountKey",
    value: "Sign up for an account",
  },
  ALREADY_HAVE_AN_ACCOUNT: {
    key: "alreadyHaveAnAccountKey",
    value: "Already have an account?",
  },
  LOGIN: {
    key: "loginKey",
    value: "Login",
  },
  OR_CONTINUE_WITH: {
    key: "orContinueWithKey",
    value: "Or continue with",
  },
  PASSWORDS_DONT_MATCH: {
    key: "passwordsDontMatchKey",
    value: "Passwords don't match",
  },
  REQUIRED: {
    key: "requiredKey",
    value: "Required",
  },
  INVALID_EMAIL_FORMAT: {
    key: "invalidEmailKey",
    value: "Invalid email format",
  },
  EMAIL_ADDRESS: {
    key: "emailAddressKey",
    value: "Email address",
  },
  MIN_PASS_LENGTH: {
    key: "minPassLengthKey",
    value: "Minimal length 6 symbols",
  },
  PASSWORD: {
    key: "passwordKey",
    value: "Password",
  },
  CONFIRM_PASSWORD: {
    key: "confirmPasswordKey",
    value: "Confirm password",
  },
  JOIN: {
    key: "joinKey",
    value: "join",
  },
  SIGN_IN_TO_YOUR_ACCOUNT: {
    key: "signInToYourAccountKey",
    value: "Sign in to your account",
  },
  NOT_A_MEMBER: {
    key: "notAMemberKey",
    value: "Not a member?",
  },
  SIGN_UP_NOW: {
    key: "signUpNowKey",
    value: "Sign up now",
  },
  FORGOT_PASSWORD: {
    key: "forgotPasswordKey",
    value: "Forgot password?",
  },
  CHECK_YOUR_EMAIL_TO_UPDATE_YOUR_PASSWORD: {
    key: "checkYourEmailToUpdateYourPasswordKey",
    value: "Check your email to update your password",
  },
  SEND_EMAIL: {
    key: "sendEmailKey",
    value: "Send reset link",
  },
  CHANGE_VOICE: {
    key: "changeVoiceKey",
    value: "Change voice",
  },
  EMAIL_SUPPORT: {
    key: "emailSupportKey",
    value: "Email Support",
  },
  PRIVACY_POLICY: {
    key: "privacyPolicyKey",
    value: "Privacy Policy",
  },
  TERMS_OF_SERVICE: {
    key: "termsOfServiceKey",
    value: "Terms of Service",
  },
  LANGUAGE: {
    key: "languageKey",
    value: "Language",
  },
  DELETE_MY_ACCOUNT: {
    key: "deleteMyAccountKey",
    value: "Delete my account",
  },
  DEACTIVATE_ACCOUNT: {
    key: "deactivateAccountKey",
    value: "Deactivate account",
  },
  ARE_YOU_SURE_YOU_WANT_TO_DEACTIVATE_YOUR_ACCOUNT: {
    key: "areYouSureYouWantToDeactivateYourAccountKey",
    value:
      "Are you sure you want to deactivate your account? All of your data will be permanently removed from our servers forever. This action cannot be undone.",
  },
  CANCEL: {
    key: "cancelKey",
    value: "Cancel",
  },
  DELETE: {
    key: "deleteKey",
    value: "Delete",
  },
  CHANGE_YOUR_EMAIL: {
    key: "changeYourEmailKey",
    value: "Change your email",
  },
  ARE_YOU_SURE_THAT_YOU_WANT_TO_CHANGE_YOUR_EMAIL: {
    key: "areYouSureThatYouWantToChangeYourEmailKey",
    value: "Are you sure that you want to change your email?",
  },
  CHANGE: {
    key: "changeKey",
    value: "Change",
  },
  AN_INVALID_VALUE_WAS_ENTERED_CHECK_THAT_THE_CONFIRMATION_CODE_IS_ENTERED_CORRECTLY_AND_TRY_AGAIN:
    {
      key: "anInvalidValueWasEnteredCheckThatTheConfirmationCodeIsEnteredCorrectlyAndTryAgainKey",
      value:
        "An invalid value was entered. Check that the confirmation code is entered correctly and try again.",
    },
  ENTER_CONFIRMATION_CODE: {
    key: "enterConfirmationCodeKey",
    value: "Enter Confirmation Code",
  },
  WE_HAVE_SENT_A_CONFIRMATION_CODE_TO_YOUR_CURRENT_EMAIL: {
    key: "weHaveSentAConfirmationCodeToYourCurrentEmailKey",
    value: "We have sent a confirmation code to your current email",
  },
  CONFIRMATION_CODE: {
    key: "confirmationCodeKey",
    value: "Confirmation code",
  },
  CONFIRM: {
    key: "confirmKey",
    value: "Confirm",
  },
  ENTER_NEW_EMAIL: {
    key: "enterNewEmailKey",
    value: "Enter New Email",
  },
  YOUR_ACCOUNT_WILL_BE_LINKED_TO_THE_SPECIFIED_EMAIL: {
    key: "yourAccountWillBeLinkedToTheSpecifiedEmailKey",
    value: "Your account will be linked to the specified email",
  },
  NEW_EMAIL: {
    key: "newEmailKey",
    value: "New email",
  },
  SET_NEW_EMAIL: {
    key: "setNewEmailKey",
    value: "Set new email",
  },
  YOUR_EMAIL_WAS_UPDATED: {
    key: "yourEmailWasUpdatedKey",
    value: "Your email was updated",
  },
  NOW_YOU_NEED_TO_USE_NEW_EMAIL: {
    key: "nowYouNeedToUseNewEmailKey",
    value: "Now you need to use a new email to log into your account",
  },
  FINAL_STEP: {
    key: "finalStepKey",
    value: "Final Step!",
  },
  A_CONFIRMATION_CODE_HAS_BEEN_SENT_TO_YOUR_NEWLY_PROVIDED_EMAIL_ADDRESS_PLEASE_BE_AWARE_THAT_THIS_ACTION_ONCE_COMPLETED_CANNOT_BE_REVERSED:
    {
      key: "aConfirmationCodeHasBeenSentToYourNewlyProvidedEmailAddressPleaseBeAwareThatThisActionOnceCompletedCannotBeReversedKey",
      value:
        "A confirmation code has been sent to your newly provided email address. Please be aware that this action, once completed, cannot be reversed.",
    },
  TYPE_OR_PASTE_TEXT: {
    key: "typeOrPasteTextKey",
    value: "Type or Paste Text",
  },
  ADD_ANY_TEXT: {
    key: "addAnyTextKey",
    value: "Add any text",
  },
  WRITE_OR_PASTE_ANYTHING: {
    key: "writeOrPasteAnythingKey",
    value: "Write or paste anything",
  },
  GENERATING_AUDIO: {
    key: "generatingAudioKey",
    value: "Generating audio...",
  },
  HIGHLIGHT_GENERATING: {
    key: "highlightGeneratingKey",
    value: "Word highlighting is still being generated…",
  },
  UNTITLED: {
    key: "untitledKey",
    value: "Untitled",
  },
  CONTINUE: {
    key: "continueKey",
    value: "Continue",
  },
  TYPE_YOUR_NOTE_HERE: {
    key: "typeYourNoteHereKey",
    value: "Type your note here",
  },
  ANY_WEBSITE: {
    key: "anyWebsiteKey",
    value: "any webiste",
  },
  WEB_LINK: {
    key: "webLinkKey",
    value: "Web Link",
  },
  PASTE_ANY_URL_TO_LISTEN: {
    key: "pasteAnyUrlToListenKey",
    value: "Paste any URL to listen",
  },
  INVALID_LINK: {
    key: "invalidLinkKey",
    value: "Invalid link",
  },
  LOADING: {
    key: "loadingKey",
    value: "Loading",
  },
  SPEED: {
    key: "speedKey",
    value: "Speed",
  },
  PRODUCTIVITY_BOOST: {
    key: "productivityBoostKey",
    value: "Productivity boost",
  },
  PLEASE_WAIT_WHILE_WE_SET_EVERYTHING_UP_FOR_YOU: {
    key: "pleaseWaitWhileWeSetEverythingUpForYouKey",
    value: "Please wait while we set everything up for you",
  },
  PREPARING_RESOURCES: {
    key: "preparingResourcesKey",
    value: "Preparing resources",
  },
  LOADING_CONTENT_DATA: {
    key: "loadingContentDataKey",
    value: "Loading content data",
  },
  OPTIMIZING_PERFORMANCE: {
    key: "optimizingPerformanceKey",
    value: "Optimizing performance",
  },
  FINALIZING_SETUP: {
    key: "finalizingSetupKey",
    value: "Finalizing setup",
  },
  ALMOST_THERE: {
    key: "almostThereKey",
    value: "Almost there",
  },
  PDF_AND_MORE: {
    key: "pdfAndMoreKey",
    value: "PDF & more",
  },
  CONVERT_ANY_DOCUMENTS_TO_AUDIO: {
    key: "convertAnyDocumentsToAudioKey",
    value: "Convert any documents to audio (pdf, words, etc.)",
  },
  CONVERT_URLS_TO_AUDIO: {
    key: "convertUrlsToAudioKey",
    value: "Convert URLs to audio",
  },
  ANY_CUSTOM_TEXT: {
    key: "anyCustomTextKey",
    value: "Any Custom Text",
  },
  INPUT_OR_PASTE_TEXT_TO_LISTEN: {
    key: "inputOrPasteTextToListenKey",
    value: "Input or paste text to listen",
  },
  ANY_CUSTOM_TEXT_TO_LISTEN: {
    key: "anyCustomTextToListenKey",
    value: "Any Custom Text to listen",
  },
  TEXT_TO_AUDIO_CONVERTER: {
    key: "textToAudioConverterKey",
    value: "Text-to-Audio Converter",
  },
  TURN_ANY_TEXT_INTO_ENGAGING_AUDIO: {
    key: "turnAnyTextIntoEngagingAudioKey",
    value:
      "Turn any text into engaging audio. Select your preferred input method to begin.",
  },
  WHAT_DO_YOU_WANT_TO_LISTEN_TO: {
    key: "whatDoYouWantToListenToKey",
    value: "What do you want to listen to?",
  },
  SOMETHING_WENT_WRONG: {
    key: "somethingWentWrongKey",
    value: "Something went wrong",
  },
  AF_ALLOY_DESC: {
    key: "afAlloyDescKey",
    value: "Our best voice—great for any purpose",
  },
  AF_AOEDE_DESC: {
    key: "afAoedeDescKey",
    value: "Melodic American, ideal for audiobooks",
  },
  AF_BELLA_DESC: {
    key: "afBellaDescKey",
    value: "Youthful American, great for educational content",
  },
  AF_KORE_DESC: {
    key: "afKoreDescKey",
    value: "Energetic American, perfect for commercials",
  },
  AF_NICOLE_DESC: {
    key: "afNicoleDescKey",
    value: "Professional American, suited for business presentations",
  },
  AF_NOVA_DESC: {
    key: "afNovaDescKey",
    value: "Dynamic American, ideal for podcasts",
  },
  AF_SARAH_DESC: {
    key: "afSarahDescKey",
    value: "Friendly American, great for customer service",
  },
  AM_ECHO_DESC: {
    key: "amEchoDescKey",
    value: "Clear American, perfect for announcements",
  },
  AM_ERIC_DESC: {
    key: "amEricDescKey",
    value: "Confident American, suited for motivational content",
  },
  AM_FENRIR_DESC: {
    key: "amFenrirDescKey",
    value: "Deep American, ideal for dramatic narratives",
  },
  AM_MICHAEL_DESC: {
    key: "amMichaelDescKey",
    value: "Authoritative American, great for documentaries",
  },
  AM_ONYX_DESC: {
    key: "amOnyxDescKey",
    value: "Smooth American, perfect for luxury brand content",
  },
  AM_PUCK_DESC: {
    key: "amPuckDescKey",
    value: "Playful American, ideal for children's content",
  },
  BF_ALICE_DESC: {
    key: "bfAliceDescKey",
    value: "Sophisticated British, excellent for audiobooks",
  },
  BF_EMMA_DESC: {
    key: "bfEmmaDescKey",
    value: "Warm British, perfect for lifestyle content",
  },
  BF_ISABELLA_DESC: {
    key: "bfIsabellaDescKey",
    value: "Elegant British, suited for luxury brand narratives",
  },
  BM_FABLE_DESC: {
    key: "bmFableDescKey",
    value: "Enchanting British, ideal for storytelling",
  },
  BM_GEORGE_DESC: {
    key: "bmGeorgeDescKey",
    value: "Authoritative British, great for news broadcasts",
  },
  BM_LEWIS_DESC: {
    key: "bmLewisDescKey",
    value: "Friendly British, perfect for travel content",
  },
  NOW_FOR_THE_FUN_PART_LET_S_PICK_A_VOICE: {
    key: "nowForTheFunPartLetsPickAVoiceKey",
    value: "Now for the fun part—let's pick a voice!",
  },
  CHOOSE_WHICH_AI_VOICE_YOU_D_LIKE_FOR_YOUR_GENERATED_AUDIO_YOU_CAN_ALWAYS_CHANGE_IT_LATER_IN_SETTINGS:
    {
      key: "chooseWhichAiVoiceYouDLikeForYourGeneratedAudioYouCanAlwaysChangeItLaterInSettingsKey",
      value:
        "Choose which AI voice you'd like for your generated audio. You can always change it later in Settings.",
    },
  START_LISTENING: {
    key: "startListeningKey",
    value: "Start listening",
  },

  PDF_OR_WEB_PAGE_URL: {
    key: "pdfOrWebPageUrlKey",
    value: "PDF or Web Page URL",
  },
  LINK_TO_WEB_PAGE_OR_PDF: {
    key: "linkToWebPageOrPdfKey",
    value: "Link to web page or PDF",
  },
  PASTE_THE_URL_OF_A_WEBSITE_OR_PDF: {
    key: "pasteTheUrlOfAWebsiteOrPdfKey",
    value: "Paste the URL of a website or pdf",
  },
  CONVERT_TO_AUDIO: {
    key: "convertToAudioKey",
    value: "Convert to audio",
  },
  TEXT_IS_REQUIRED: {
    key: "textIsRequiredKey",
    value: "Text is required",
  },
  RENAME: {
    key: "renameKey",
    value: "Rename",
  },
  SAVE: {
    key: "saveKey",
    value: "Save",
  },
  ARCHIVE: {
    key: "archiveKey",
    value: "Archive",
  },
  DELETE_ITEM: {
    key: "deleteItemKey",
    value: "Delete item",
  },
  DELETE_ITEM_CONFIRMATION: {
    key: "deleteItemConfirmationKey",
    value: "Are you sure you want to delete this item?",
  },
  ALL: {
    key: "allKey",
    value: "All",
  },
  IN_PROGRESS: {
    key: "inProgressKey",
    value: "In Progress",
  },
  ARCHIVED: {
    key: "archivedKey",
    value: "Archived",
  },
  RETURN: {
    key: "returnKey",
    value: "return",
  },
  LISTEN: {
    key: "listenKey",
    value: "Listen",
  },
  LIBRARY_IS_EMPTY: {
    key: "libraryIsEmptyKey",
    value: "Library is empty",
  },
  START_LISTENING_TO_ANY_CONTENT: {
    key: "startListeningToAnyContentKey",
    value: "Start listening to any content",
  },
  PREPARING_TO_CONVERT_YOUR_TEXT_INTO_AUDIO: {
    key: "preparingToConvertYourTextIntoAudioKey",
    value: "Preparing to convert your text into audio.",
  },
  SETTING_UP_YOUR_CONTENT_FOR_CONVERSION: {
    key: "settingUpYourContentForConversionKey",
    value: "Setting up your content for conversion.",
  },
  RETRIEVING_CONTENT_AND_PREPARING_AUDIO: {
    key: "retrievingContentAndPreparingAudioKey",
    value: "Retrieving content and preparing audio.",
  },
  ENHANCING_QUALITY_FOR_THE_BEST_LISTENING_EXPERIENCE: {
    key: "enhancingQualityForTheBestListeningExperienceKey",
    value: "Enhancing quality for the best listening experience.",
  },
  WE_RE_ALMOST_DONE_JUST_A_BIT_MORE_TO_GO: {
    key: "weReAlmostDoneJustABitMoreToGoKey",
    value: "We’re almost done! Just a bit more to go.",
  },
  STARTING_CONVERSION: {
    key: "startingConversionKey",
    value: "Starting conversion",
  },
  GATHERING_RESOURCES: {
    key: "gatheringResourcesKey",
    value: "Gathering resources",
  },
  LOADING_TEXT: {
    key: "loadingTextKey",
    value: "Loading text",
  },
  OPTIMIZING_AUDIO: {
    key: "optimizingAudioKey",
    value: "Optimizing audio",
  },
  FINAZLING_CONVERSION: {
    key: "finazingConversionKey",
    value: "Finazing conversion",
  },
  CALCULATING: {
    key: "calculatingKey",
    value: "Calculating",
  },
  FULL_AUDIO_IS_DONE_WE_ARE_NOW_OPTIMIZING_IT_FOR_YOUR_DEVICE: {
    key: "fullAudioIsDoneWeAreNowOptimizingItForYourDeviceKey",
    value: "Full audio is done, we are now optimizing it for your device.",
  },
  THIS_REST_OF_AUDIO_IS_IN_BACKGROUND_PROCESSING: {
    key: "thisRestOfAudioIsInBackgroundProcessingKey",
    value: "This rest of audio is in background processing",
  },
  WHEN_AUDIO_IS_READY_IT_WILL_BE_AVAILABLE_IN_YOUR_LIBRARY: {
    key: "whenAudioIsReadyItWillBeAvailableInYourLibraryKey",
    value: "When audio is ready, it will be available in your library",
  },
  EDIT_TEXT_BEFORE_CONVERSION: {
    key: "editTextBeforeConversionKey",
    value: "Edit Text Before Conversion ?",
  },
  YOUR_FILE_MIGHT_INCLUDE_EXTRA_SYMBOLS_AND_DETAILS_THAT_AREN_T_NEEDED_FOR_THE_AUDIO_WOULD_YOU_LIKE_US_TO_REMOVE_THESE_ELEMENTS_BEFORE_CONVERTING_YOUR_TEXT_TO_SPEECH:
    {
      key: "yourFileMightIncludeExtraSymbolsAndDetailsThatArenTNeededForTheAudioWouldYouLikeUsToRemoveTheseElementsBeforeConvertingYourTextToSpeechKey",
      value:
        "Your file might include extra symbols and details (such as apostrophes, descriptive notes, author info, etc.) that aren't necessary for the audio. Would you like us to remove these elements before converting your text to speech?",
    },
  YES_CLEAN_UP_TEXT: {
    key: "yesCleanUpTextKey",
    value: "Yes, clean up text",
  },
  KEEP_ORIGINAL_TEXT: {
    key: "keepOriginalTextKey",
    value: "Keep original text",
  },
  YOU_CAN_ALWAYS_ADJUST_THIS_PREFERENCE_LATER_IN_SETTINGS: {
    key: "youCanAlwaysAdjustThisPreferenceLaterInSettingsKey",
    value: "You can always adjust this preference later in Settings.",
  },
  CLEAN_UP_TEXT_BEFORE_FILE_CONVERSION: {
    key: "cleanUpTextBeforeFileConversionKey",
    value: "Clean up text before file conversion",
  },
  UNABLE_TO_SCRAP_TEXT: {
    key: "unableToScrapTextKey",
    value:
      "We couldn’t extract the text from the URL you provided because the website prevents automated scraping. To convert your content to audio, please copy and paste the text directly into our app.",
  },
  ENTER_TEXT_MANUALLY: {
    key: "enterTextManuallyKey",
    value: "Enter Text Manually",
  },
  USED: {
    key: "usedKey",
    value: "used",
  },
  MINS_LEFT_TODAY: {
    key: "minsLeftTodayKey",
    value: "mins left today",
  },
  YOUR_USAGE_RESET_IN: {
    key: "yourUsageResetInKey",
    value: "Your usage reset in",
  },
  ON_A_FREE_PLAN_YOU_GET_20_MINS_OF_AUDIO_GENERATION_EVERY_DAY: {
    key: "onAFeePlanYouGet20MinsOfAudioGenerationEveryDayKey",
    value: "On a free plan, you get 20 minutes of audio generation every day",
  },
  GET: {
    key: "getKey",
    value: "Get",
  },
  PREMIUM: {
    key: "premiumKey",
    value: "Premium",
  },
  ENJOY_UNLIMITED_ACCESS_TO_ALL_FRATECA_FEATURES_AND_UNLIMITED_MINUTES: {
    key: "enjoyUnlimitedAccessToAllFratecaFeaturesAndUnlimitedMinutesKey",
    value:
      "Enjoy unlimited access to all Frateca Features and unlimited minutes",
  },
  START_MY_FREE_TRIAL: {
    key: "startMyFreeTrialKey",
    value: "Start my free trial!",
  },
  HOURS: {
    key: "hoursKey",
    value: "hours",
  },
  MINUTES: {
    key: "minutesKey",
    value: "minutes",
  },
  AND: {
    key: "andKey",
    value: "and",
  },
  DOWNLOAD: {
    key: "downloadKey",
    value: "Download",
  },
  ADD_CODE: {
    key: "addCodeKey",
    value: "Add Code",
  },
  APPLY: {
    key: "applyKey",
    value: "Apply",
  },
  ENTER_YOUR_CODE: {
    key: "enterYourCodeKey",
    value: "Enter your code",
  },
  ENTER_YOUR_CODE_TO_UNLOCK_SPECIAL_FEATURES_OR_DISCOUNTS: {
    key: "enterYourCodeToUnlockSpecialFeaturesOrDiscountsKey",
    value: "Enter your code to unlock special features or discounts",
  },
  SUGGEST_FEATURES: {
    key: "suggestFeaturesKey",
    value: "Suggest Features",
  },
  CAMERA: {
    key: "cameraKey",
    value: "Camera",
  },
  TAKE_A_PHOTO_OF_TEXT_TO_LISTEN: {
    key: "takeAPhotoOfTextToListenKey",
    value: "Take a photo of text to listen",
  },
  CAMERA_PERMISSION_NOT_GRANTED: {
    key: "cameraPermissionNotGrantedKey",
    value: "Camera permission not granted",
  },
  MEDIA_LIBRARY_PERMISSION_NOT_GRANTED: {
    key: "mediaLibraryPermissionNotGrantedKey",
    value: "Media library permission not granted",
  },
  FAILED_TO_TAKE_PICTURE: {
    key: "failedToTakePictureKey",
    value: "Failed to take picture",
  },
  PHOTOS: {
    key: "photosKey",
    value: "Photos",
  },
  DONE: {
    key: "doneKey",
    value: "Done",
  },
  TAP_THE_CAMERA_BUTTON_BELOW_TO_TAKE_PHOTOS: {
    key: "tapTheCameraButtonBelowToTakePhotosKey",
    value: "Tap the camera button below to take photos",
  },
  NO_PHOTOS_YET: {
    key: "noPhotosYetKey",
    value: "No photos yet",
  },
  GALLERY: {
    key: "galleryKey",
    value: "Gallery",
  },
  ARE_YOU_SURE_YOU_WANT_TO_LEAVE: {
    key: "areYouSureYouWantToLeaveKey",
    value: "Are you sure you want to leave?",
  },
  ALL_PHOTOS_WILL_BE_DELETED: {
    key: "allPhotosWillBeDeletedKey",
    value: "All photos will be deleted",
  },
  YES: {
    key: "yesKey",
    value: "Yes",
  },
  NO: {
    key: "noKey",
    value: "No",
  },
  CONVERSION_IN_PROGRESS_PROCESSING_IN_THE_BACKGROUND_YOU_CAN_CLOSE_THE_APP: {
    key: "conversionInProgressProcessingInTheBackgroundYouCanCloseTheAppKey",
    value:
      "Conversion in progress - processing in the background. You can close the app.",
  },
  PREPARING_TO_CONVERT_YOUR_TEXT_INTO_AUDIO_PLEASE_KEEP_THE_APP_OPEN: {
    key: "preparingToConvertYourTextIntoAudioPleaseKeepTheAppOpenKey",
    value:
      "Preparing to convert your text into audio. Please keep the app open",
  },
  HOLD_TO_REORDER: {
    key: "holdToReorderKey",
    value: "Hold to reorder",
  },
  TAKE_A_PHOTO_OF_THE_TEXT_OR_SELECT_AN_IMAGE_FROM_YOUR_GALLERY: {
    key: "takeAPhotoOfTheTextOrSelectAnImageFromYourGalleryKey",
    value: "Take a photo of the text or select an image from your gallery.",
  },
  YOUR_FILE_EXCEEDS_THE_CURRENT_LIMIT_OF_650_000_CHARACTERS: {
    key: "yourFileExceedsTheCurrentLimitOf650000CharactersKey",
    value: "Your file exceeds the current limit of 650,000 characters.",
  },
  WOULD_YOU_LIKE_TO_PROCEED_BY_CONVERTING_THE_FIRST_650_000_CHARACTERS_THIS_WILL_TAKE_APPROXIMATELY_20_MINUTES:
    {
      key: "wouldYouLikeToProceedByConvertingTheFirst650000CharactersThisWillTakeApproximately20MinutesKey",
      value:
        "Would you like to proceed by converting the first 650,000 characters? This will take approximately 20 minutes.",
    },
  YES_CONVERT: {
    key: "yesConvertKey",
    value: "Yes, convert",
  },
  NO_CANCEL_CONVERSION: {
    key: "noCancelConversionKey",
    value: "No, cancel conversion",
  },
  WE_COULD_NOT_DETECT_ANY_TEXT_IN_YOUR_IMAGE: {
    key: "weCouldNotDetectAnyTextInYourImageKey",
    value: "We couldn’t detect any text in your image",
  },
  PLEASE_ENSURE_THE_PHOTO_CLEARLY_SHOWS_THE_TEXT_AND_TRY_UPLOADING_IT_AGAIN: {
    key: "pleaseEnsureThePhotoClearlyShowsTheTextAndTryUploadingItAgainKey",
    value:
      "Please ensure the photo clearly shows the text and try uploading it again",
  },
  TRY_AGAIN: {
    key: "tryAgainKey",
    value: "Try Again",
  },
  AUDIO_TEXT: {
    key: "audioTextKey",
    value: "Audio Text",
  },
  STYLED_VIEW: {
    key: "styledViewKey",
    value: "Styled View",
  },
  ENJOYING_THE_APP: {
    key: "enjoyingTheAppKey",
    value: "Enjoying the app?",
  },
  WE_D_LOVE_TO_HEAR_YOUR_THOUGHTS: {
    key: "weDLoveToHearYourThoughtsKey",
    value: "We'd love to hear your thoughts!",
  },
  SUBMIT_RATING: {
    key: "submitRatingKey",
    value: "Submit Rating",
  },
  MAYBE_LATER: {
    key: "maybeLaterKey",
    value: "Maybe Later",
  },
  THANKS_FOR_YOUR_5_STAR_RATING: {
    key: "thanksForYour5StarRatingKey",
    value: "Thanks for your 5-star rating!",
  },
  WOULD_YOU_LIKE_TO_SHARE_YOUR_POSITIVE_EXPERIENCE_WITH_OTHERS_BY_LEAVING_A_REVIEW_ON_THE:
    {
      key: "wouldYouLikeToShareYourPositiveExperienceWithOthersByKey",
      value:
        "Would you like to share your positive experience with others by leaving a review on the",
    },
  LEAVE_A_REVIEW: {
    key: "leaveAReviewKey",
    value: "Leave a Review",
  },
  NO_THANKS: {
    key: "noThanksKey",
    value: "No, Thanks",
  },
  PLEASE_LET_US_KNOW_HOW_WE_CAN_IMPROVE_YOUR_EXPERIENCE: {
    key: "pleaseLetUsKnowHowWeCanImproveYourExperienceKey",
    value: "Please let us know how we can improve your experience.",
  },
  WE_RE_SORRY_TO_HEAR_THAT: {
    key: "weReSorryToHearThatKey",
    value: "We're sorry to hear that",
  },
  WHAT_CAN_WE_DO_BETTER: {
    key: "whatCanWeDoBetterKey",
    value: "What can we do better?",
  },
  SUBMIT_FEEDBACK: {
    key: "submitFeedbackKey",
    value: "Submit Feedback",
  },
  THANK_YOU: {
    key: "thankYouKey",
    value: "Thank you!",
  },
  WE_APPRECIATE_YOUR_FEEDBACK_AND_WILL_USE_IT_TO_IMPROVE_OUR_APP: {
    key: "weAppreciateYourFeedbackAndWillUseItToImproveOurAppKey",
    value: "We appreciate your feedback and will use it to improve our app.",
  },
  CLOSE: {
    key: "closeKey",
    value: "Close",
  },
  DOWNLOADING: {
    key: "downloadingKey",
    value: "Downloading",
  },
  FILE_DOWNLOADED: {
    key: "fileDownloadedKey",
    value: "File downloaded",
  },
  DOWNLOAD_FAILED: {
    key: "downloadFailedKey",
    value: "Download failed",
  },
  TRANSFERING_DATA: {
    key: "transferingDataKey",
    value: "Transfering data",
  },
  PROCESSING_TEXT: {
    key: "processingTextKey",
    value: "Processing text",
  },
  CONVERTING: {
    key: "convertingKey",
    value: "Converting",
  },
  THE_FIRST_PART_OF_THE_AUDIO_IS_READY: {
    key: "theFirstPartOfTheAudioIsReadyKey",
    value: "The first part of the audio is ready.",
  },
  THE_FULL_FILE_IS_STILL_PROCESSING_AND_WILL_UPLOAD_AUTOMATICALLY_ONCE_COMPLETE:
    {
      key: "theFullFileIsStillProcessingAndWillUploadAutomaticallyOnceCompleteKey",
      value:
        "The full file is still processing and will upload automatically once complete.",
    },
  PRCESSING_NOW: {
    key: "prcessingNowKey",
    value: "Processing now",
  },
  ALREADY_PROCESSING: {
    key: "alreadyProcessingKey",
    value: "Already processing",
  },
  PLEASE_WAIT_FOR_THE_CURRENT_PROCESS_TO_COMPLETE: {
    key: "pleaseWaitForTheCurrentProcessToCompleteKey",
    value: "Please wait for the current process to complete",
  },
  CONVERT_TEXT_INTO_ENGAGING_AUDIO_CHOOSE_HOW_YOU_D_LIKE_TO_ADD_IT: {
    key: "convertTextIntoEngagingAudioChooseHowYouDLikeToAddItKey",
    value:
      "Convert text into engaging audio - choose how you’d like to add it.",
  },
  DOCUMENTS: {
    key: "documentsKey",
    value: "Documents",
  },
  LISTEN_TO_YOUR_PDFS_WORD_FILES_BOOKS_AND_MORE: {
    key: "listenToYourPDFsWordFilesBooksAndMoreKey",
    value: "Listen to your PDFs, Word files, books and more",
  },
  WEB_ARTICLES_SITES: {
    key: "webArticlesSitesKey",
    value: "Web Articles & Sites",
  },
  TURN_ANY_WEB_PAGE_OR_ARTICLE_LINK_INTO_AUDIO: {
    key: "turnAnyWebPageOrArticleLinkIntoAudioKey",
    value: "Turn any web page or article link into audio",
  },
  PASTED_TEXT: {
    key: "pastedTextKey",
    value: "Pasted Text",
  },
  TYPE_OR_PASTE_ANY_TEXT_TO_HEAR_IT_READ_ALOUD: {
    key: "typeOrPasteAnyTextToHearItReadAloudKey",
    value: "Type or paste any text to hear it read aloud",
  },
  TEXT_FROM_IMAGES: {
    key: "textFromImagesKey",
    value: "Text from images",
  },
  USE_YOUR_CAMERA_TO_CAPTURE_AND_LISTEN_TO_PRINTED_TEXT: {
    key: "useYourCameraToCaptureAndListenToPrintedTextKey",
    value: "Use your camera to capture and listen to printed text",
  },
  RENDERING_PDF: {
    key: "renderingPdfKey",
    value: "Rendering PDF",
  },
  DOWNLOADING_AUDIO: {
    key: "downloadingAudioKey",
    value: "Downloading audio",
  },
  AUTO_SCROLL: {
    key: "autoScrollKey",
    value: "Auto Scroll",
  },
  CANCEL_PROCESSING: {
    key: "cancelProcessingKey",
    value: "Cancel processing",
  },
  CANCEL_PROCESSING_DESCRIPTION: {
    key: "cancelProcessingDescriptionKey",
    value:
      "This will revert the changes. Are you sure you want to stop the processing?",
  },
  PROCESSING_CANCELLED: {
    key: "processingCancelledKey",
    value: "Processing cancelled",
  },
  ENGLISH: {
    key: "englishKey",
    value: "English",
  },
  JAPANESE: {
    key: "japaneseKey",
    value: "Japanese",
  },
  CHINESE: {
    key: "chineseKey",
    value: "Chinese",
  },
  SPANISH: {
    key: "spanishKey",
    value: "Spanish",
  },
  FRENCH: {
    key: "frenchKey",
    value: "French",
  },
  HINDI: {
    key: "hindiKey",
    value: "Hindi",
  },
  ITALIAN: {
    key: "italianKey",
    value: "Italian",
  },
  PORTUGUESE: {
    key: "portugueseKey",
    value: "Portuguese",
  },
  PICK_YOUR_VOICE_LANGUAGE: {
    key: "pickYourVoiceLanguageKey",
    value: "Pick a language for your audio’s voice",
  },
  DON_T_WORRY_YOU_CAN_SWITCH_IT_ANYTIME_LATER_IN_SETTINGS: {
    key: "dontWorryYouCanSwitchItAnytimeLaterInSettingsKey",
    value: "Don’t worry, you can switch it anytime later in settings!",
  },
  PICK_LANGUAGE: {
    key: "pickLanguageKey",
    value: "Pick language",
  },
  CHANGE_LANGUAGE: {
    key: "changeLanguageKey",
    value: "Change language",
  },
  UNLOCK_THE_POWER_OF_LISTENING: {
    key: "unlockThePowerOfListeningKey",
    value: "Unlock the power of listening",
  },
  SAVE_TIME_BY_LISTENING_TO_TEXTBOOKS_PAPERS_PDFS_AND_WEB_PAGES_ANYTIME_ANYWHERE:
    {
      key: "saveTimeByListeningToTextbooksPapersPdfsAndWebPagesAnytimeAnywhereKey",
      value:
        "Save time by listening to textbooks, papers, PDFs, and web pages anytime, anywhere",
    },
  CONTINUE_WITH_EMAIL: {
    key: "continueWithEmailKey",
    value: "Continue with Email",
  },
  CONTINUE_WITH_GOOGLE: {
    key: "continueWithGoogleKey",
    value: "Google",
  },
  RESET_YOUR_PASSWORD: {
    key: "resetYourPasswordKey",
    value: "Reset password",
  },
  CONFIRMATION_CODE_EXPIRED: {
    key: "confirmationCodeExpiredKey",
    value: "Confirmation code is expired",
  },
  A_CONFIRMATION_CODE_HAS_EXPIRED_PLEASE_REQUEST_A_NEW_CODE: {
    key: "aConfirmationCodeHasExpiredPleaseRequestANewCodeKey",
    value: "A confirmation code has expired. Please request a new code.",
  },
  REQUEST_NEW_CODE: {
    key: "requestNewCodeKey",
    value: "Request new code",
  },
  RESEND_CONFIRMATION_CODE_IN: {
    key: "resendConfirmationCodeInKey",
    value: "Resend confirmation code in",
  },
  RESEND_CONFIRMATION_CODE: {
    key: "resendConfirmationCodeKey",
    value: "Resend confirmation code",
  },
  THIS_WILL_RESEND_THE_CONFIRMATION_CODE_TO_YOUR_EMAIL: {
    key: "thisWillResendTheConfirmationCodeToYourEmailKey",
    value: "This will resend the confirmation code to your email",
  },
  RESEND: {
    key: "resendKey",
    value: "Resend",
  },
  ENTER_THE_CONFIRMATION_CODE: {
    key: "enterTheConfirmationCodeKey",
    value: "Enter the confirmation code",
  },
  A_CONFIRMATION_CODE_HAS_BEEN_SENT_TO_YOUR_EMAIL: {
    key: "aConfirmationCodeHasBeenSentToYourEmailKey",
    value: "A confirmation code has been sent to your email",
  },
  SIGN_UP: {
    key: "signUpKey",
    value: "Sign up",
  },
  OR_CONTINUE_WITH_EMAIL: {
    key: "orContinueWithEmailKey",
    value: "or",
  },
  SIGN_IN: {
    key: "signInKey",
    value: "Sign in",
  },
  GET_STARTED: {
    key: "getStartedKey",
    value: "Create account",
  },
  CONTINUE_WITH_APPLE: {
    key: "continueWithAppleKey",
    value: "Apple",
  },
  WELCOME_BACK: {
    key: "welcomeBackKey",
    value: "Sign in",
  },
  SIGN_IN_TO_CONTINUE: {
    key: "signInToContinueKey",
    value: "Access your audio library",
  },
  CREATE_YOUR_ACCOUNT: {
    key: "createYourAccountKey",
    value: "Create account",
  },
  START_LISTENING_IN_SECONDS: {
    key: "startListeningInSecondsKey",
    value: "Start listening for free",
  },
  ENTER_EMAIL_FOR_RESET_LINK: {
    key: "enterEmailForResetLinkKey",
    value: "We'll send a reset link to your email",
  },
}
